import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { SelectedImage } from 'types'
import { useSections } from './SectionsProvider'
import { NewsletterSection } from './Types'
import { useImages } from 'components/Wizards/SelectImages/ImagesProvider'
import { IconProps } from 'blaze-ui/icons/Types'
import { ButtonVariant } from 'blaze-ui/Button/Types'
import { SelectImageButtonDesktop } from './SelectImageButtonDesktop'
import { SelectImageButtonMobile } from './SelectImageButtonMobile'
import { useField } from 'formik'

interface Props {
  section: NewsletterSection
  label: string
  frontIcon?: React.ForwardRefExoticComponent<IconProps & React.RefAttributes<SVGSVGElement>>
  brandKitId?: number
}

export const SelectImageButton = ({ section, label, frontIcon, brandKitId }: Props) => {
  const { isMobile } = useResponsiveDesign()
  const { addImage } = useSections()
  const { imageKeywords } = useImages()
  const [helper] = useField<number>('brand_kit_id')

  const handleAdd = async (pickerImages: SelectedImage[]) => {
    addImage(section, pickerImages[0].url)
  }

  const props = {
    label,
    frontIcon,
    onAdd: handleAdd,
    initialQuery: imageKeywords[0],
    showAiConfirm: false,
    variant: 'secondary' as ButtonVariant,
    brandKitId: helper.value,
  }

  return isMobile ? <SelectImageButtonMobile {...props} /> : <SelectImageButtonDesktop {...props} />
}
